import { useMemo } from 'react';
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  format,
  isSameMonth,
  isToday,
} from 'date-fns';
import { cn } from '@/lib/cn';

const WEEK_DAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];

export default function MiniCalendar() {
  const today = useMemo(() => new Date(), []);
  const monthStart = startOfMonth(today);
  const monthEnd = endOfMonth(today);

  const calStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const calEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });

  const days = useMemo(
    () => eachDayOfInterval({ start: calStart, end: calEnd }),
    [calStart, calEnd],
  );

  return (
    <div>
      {/* Month label */}
      <p className="text-sm font-medium text-gray-900 mb-3">
        {format(today, 'MMMM yyyy')}
      </p>

      {/* Weekday headers */}
      <div className="grid grid-cols-7 mb-1">
        {WEEK_DAYS.map((d) => (
          <span
            key={d}
            className="text-center text-[11px] font-medium text-gray-400 py-1"
          >
            {d}
          </span>
        ))}
      </div>

      {/* Days */}
      <div className="grid grid-cols-7 gap-px">
        {days.map((day) => {
          const inMonth = isSameMonth(day, today);
          const todayMatch = isToday(day);
          return (
            <span
              key={day.toISOString()}
              className={cn(
                'flex h-8 w-full items-center justify-center rounded text-xs',
                'transition-all duration-200 ease-in-out',
                !inMonth && 'text-gray-300',
                inMonth && !todayMatch && 'text-gray-600',
                todayMatch &&
                  'bg-indigo-600 text-white font-semibold rounded-md',
              )}
            >
              {format(day, 'd')}
            </span>
          );
        })}
      </div>
    </div>
  );
}
